import { css } from "@emotion/react";

import { white } from "../../styles/variables";

export const dialog = css`
  .MuiDialog-paper {
    border-radius: unset;
    background-color: black;
  }
`;

export const dialogContent = css`
  width: 600px;
  height: 100%;
  padding: 0;

  /* margin-bottom: -5px; */

  &:first-child {
    padding: 0;
  }
`;

export const readyDialogContent = css`
  > div {
    display: flex;
    align-items: center;
  }
`;

export const video = css`
  &:focus {
    outline: none;
  }
`;

export const backdrop = css`
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  padding: 20px;
`;

export const backButton = css`
  color: ${white};
  &.MuiButton-root:hover {
    background-color: unset;
  }
`;

export const player = css`
  height: 50vh;
  min-height: 450px;
  width: 100%;
  background: ${white};
  overflow: hidden;
`;

export const iframe = css`
  width: 100%;
  height: 100%;
  border: none;
`;
